import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { CheckIfChildHasPropertyHref } from '../../../utils/md-utils/md-utils';

import check from '../../../images/check.svg';
import arrow from '../../../images/small-arrow-right.svg';

type ListItemProps = React.ComponentPropsWithoutRef<'li'> & {
  children?: React.ReactNode;
};

const ListItem = ({ children }: ListItemProps) => {
  const isListItemWithLink = CheckIfChildHasPropertyHref(children);

  return (
    <StyledListItem isAnchorLink={isListItemWithLink}>
      {children}
    </StyledListItem>
  );
};

export default ListItem;

const StyledListItem = styled.li<{ isAnchorLink?: boolean }>`
  list-style: none;
  position: relative;

  &:before {
    background: url(${({ isAnchorLink }) => (isAnchorLink ? arrow : check)})
      no-repeat;
    content: '';
    height: 1rem;
    left: -21px;
    position: absolute;
    top: 6px;
    transition: 0.1s ease-in-out;
    width: 1rem;
  }

  ${({ isAnchorLink }) =>
    isAnchorLink
      ? css`
          &:hover {
            &:before {
              left: -14px;
            }
          }
        `
      : undefined}
`;
